define('Facets.MultiAddToCart.Quantity.View', [
    'facets_multi_add_to_cart_qty.tpl',

    'Backbone'
], function (
    facets_multi_add_to_cart_qty_tpl,

    Backbone
) {
    'use strict';

    return Backbone.View.extend({
        template: facets_multi_add_to_cart_qty_tpl,

        events: {
            'change [name="quantity"]': 'onQuantityChange'
        },

        // contextDataRequest: ['item'],

        onQuantityChange: function onQuantityChange(e) {
            var $target = this.$(e.target);
            var qty = $target.val();
            var grindOption = $target.parent().parent().parent().parent().parent().find('.multi-lineoptions');
            var lineOptionVal = grindOption.find(":selected").val();
            // console.log('grindOption', grindOption);
            // console.log('lineOptionVal', lineOptionVal);
            this.multiAddToCart(qty, lineOptionVal);
            this.trigger('addToCartRefresh');
            return e.preventDefault() || e.stopPropagation();
        },

        initialize: function initialize(options) {
            var _this = this;
            if (options.addToCartViews.length) {
                this.on('addToCartRefresh', function addToCartRefresh() {
                    options.addToCartViews.forEach(function eachView(view) {
                        view.render();
                    });
                })
            }
            _this.environment = options.container.getComponent('Environment');
            _this.plp = options.container.getComponent('PLP');
            _this.getRegistrationType = options.getRegistrationType;
            _this.item = options.item;
        },

        render: _(Backbone.View.prototype.render).wrap(function render(fn) {
            var _this = this;
            var args = arguments;
            var userProfile = _this.options.container.getComponent('UserProfile');

            userProfile.getUserProfile().done(function (profile) {
                _this.userProfile = profile;
            }).always(function () {
                fn.apply(_this, _(args).toArray().slice(1));
            });
        }),

        disableQuantity: function () {
            //We've got to disable loginToSeePrices feature if customer registration is disabled.
            var _this = this;
            var configuration = _this.options.container.getComponent('Environment');
            return _this.getRegistrationType !== 'disabled' && configuration.getSiteSetting('requireloginforpricing') === 'T' && _this.userProfile.isloggedin !== true;
        },

        multiAddToCart: function multiAddToCart(qty, optionVal) {
            var item = this.item;
            var itemKey = String(item.internalid);

            if (!SC.SESSION) {
                SC.SESSION = {};
            }

            if (!SC.SESSION.multiAddToCart) {
                SC.SESSION.multiAddToCart = {};
            }

            SC.SESSION.multiAddToCart[itemKey] = {
                quantity: parseInt(qty, 10),
                item: {
                    internalid: item.internalid,
                    itemtype: item.itemtype
                },
                options: [{cartOptionId: "custcol_web_grinds", value : {internalid: optionVal}}]
            };
        },

        getContext: function getContext() {
            var lineItem;
            var lineItemKey;
            var _this = this;
            var childItem;
            var categoryinfo;
            var categoryName;
            // _this.item = _this.contextData.item && _this.contextData.item();

            var isMatrixItem = _this.item && _this.item.matrixchilditems_detail ? true : false;
            var urlComponent = '/' + _this.item.urlcomponent;
            var isNotPurchaseable = !this.item.ispurchasable ;


            lineItemKey = String(_this.item.internalid);
            lineItem = SC.SESSION && SC.SESSION.multiAddToCart && SC.SESSION.multiAddToCart[lineItemKey];

            // console.log('urlComponent', urlComponent)
            // console.log('registrationmandatory', configuration.getSiteSetting('registration.registrationmandatory'))
            // console.log('registrationallowed', configuration.getSiteSetting('registration.registrationallowed'))
            if(isMatrixItem) {
                categoryinfo = _this.plp.getCategoryInfo();
                categoryName = categoryinfo && categoryinfo.name;
                
                childItem = _.findWhere(_this.item.matrixchilditems_detail, {custitem_ma2c_category: categoryName});
                if(childItem) {
                    _.each(_this.item.itemoptions_detail && _this.item.itemoptions_detail.fields, function (field){
                        var optionValue = _.findWhere(field && field.values, {label: childItem[field.sourcefrom]});
                        if(optionValue) {
                            urlComponent +=  field.internalid + '=' + optionValue.internalid + '&';
                        }   
                    });
                    if(urlComponent.endsWith('&')) {
                        urlComponent = urlComponent.slice(0, -1);
                    }
                    isNotPurchaseable = !childItem.ispurchasable;
                    lineItemKey = String(_this.item.internalid);
                    lineItem = SC.SESSION && SC.SESSION.multiAddToCart && SC.SESSION.multiAddToCart[lineItemKey]; 
                    this.item = childItem;
                }
            }

            return {
                isQuantityEnabled: !_this.disableQuantity(), // disable quantity or not depends on Parent
                item: this.item || {},
                urlComponent: urlComponent,
                qty: lineItem ? lineItem.quantity : 0,
                isNotPurchasable: isNotPurchaseable
            };
        }
    });
});
